import { Breadcrumb, Button, ConfigProvider, DatePicker, Flex, Row, Space, Tabs } from "antd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import MyTimesheetTable from "./MyTimesheetTable";

import dayjs from "dayjs";
import MyTimesheetCalendar from "./MyTimesheetCalendar";
import UpdateMyTimesheetPage from "../pages/UpdateMyTimesheetPage";
import { useEffect, useState } from "react";
import MyTimesheetDetailModal from "./MyTimesheetDetailModal";
import MyTimesheetUpdateModal from "./MyTimesheetUpdateModal";
import useUpdateMyTimesheet from "../hooks/useUpdateMyTimesheet";
import { useSelector } from "react-redux";

const MyTimesheet = ({
    columns = [],
    onDateChange = () => { },
    timesheetCalendar = [],
    transformTimesheetData = [],
    currentDate = "",
    CustomExpandIcon = () => { },
    isModalOpen = false,
    isUpdateModalOpen = false,
    setIsModalOpen = () => { },
    setIsUpdateModalOpen = () => { },
    isUpdateMode = false,
    setIsUpdateMode = () => { },
    selectedCell,
    timesheetOptions = [],
    roleOptions = [],
    taskOptions = [],
    setSelectedTimeSheetId = () => { },
    setSelectedRoleId = () => { },
    onUpdateTimesheet = () => { },
    modalDetail = () => { },
    modalUpdateTimesheet = () => { }
}) => {
    const { t, i18n } = useTranslation();
    const [selectedMenu, setSelectedMenu] = useState('my_timesheet_calendar');
    const { roles } = useSelector((state) => state.company);

    const menuBreadcrumbMapping = {
        'my_timesheet_calendar': t('my_timesheet.header'),
        'update_timesheet': t('my_timesheet.label.update_timesheet'),
    }

    const handleTabChange = (key) => {
        setSelectedMenu(key);
    };

    useEffect(() => {
        console.log("selectedCell table", selectedCell);

    }, [selectedCell])

    return (
        <MainLayout>
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("timesheet.header"), href: "" },
                        { title: t("my_timesheet.header"), href: "" },
                        { title: menuBreadcrumbMapping[selectedMenu] || null },
                    ]} />
                    <h2>{menuBreadcrumbMapping[selectedMenu] || t("my_timesheet.header")}</h2>
                </Flex>

                <ConfigProvider
                    theme={{
                        components: {
                            Tabs: {
                                itemHoverColor: "var(--tab-color)",
                                itemActiveColor: "var(--tab-color)"
                            },
                        },
                    }}
                >
                    <Tabs destroyInactiveTabPane={true} defaultActiveKey="my_timesheet_calendar" onChange={handleTabChange}>

                        {roles.includes("ACCESS_TIMESHEET|MY_TIMESHEET|MY_TIMESHEET") && (
                            <Tabs.TabPane tab={t('my_timesheet.header')} key={"my_timesheet_calendar"}>
                                <>
                                    <MyTimesheetCalendar
                                        onDateChange={onDateChange}
                                        currentDate={currentDate}
                                        columns={columns}
                                        timesheetCalendar={timesheetCalendar}
                                        transformTimesheetData={transformTimesheetData}
                                        isUpdateMode={isUpdateMode}
                                        setIsUpdateMode={setIsUpdateMode}
                                    />
                                    {isUpdateMode
                                        ? modalUpdateTimesheet()
                                        : modalDetail()}
                                </>
                            </Tabs.TabPane>
                        )}

                        {roles.includes("ACCESS_TIMESHEET|MY_TIMESHEET|UPDATE_TIMESHEET") && (
                            <Tabs.TabPane tab={t('my_timesheet.label.update_timesheet')} key={"update_timesheet"}>
                                <UpdateMyTimesheetPage />
                            </Tabs.TabPane>
                        )}

                    </Tabs>
                </ConfigProvider>
            </Space>
        </MainLayout>
    )
}

export default MyTimesheet;